<template>
  <section class="pricing section" :class="[
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color'
  ]">
  <div class="container">

    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200">

        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-20">
          <h2 class="h2">{{ $t('qanda') }}</h2>
        </div>

        <!-- Faqs -->
        <vsa-list>
          <!-- Here you can use v-for to loop through items  -->
          <vsa-item class="max-w-6xl">
            <vsa-heading>
              Kan ik een werkend demosysteem zien?
            </vsa-heading>
            <vsa-content>
              Ja natuurlijk. Neem contact met ons op en we kunnen u laten zien hoe het werkt in een echte implementatie op een echte boerderij.
            </vsa-content>
          </vsa-item>
          <vsa-item>
            <vsa-heading>
             Hoe en waar de subsidie aanvragen?
            </vsa-heading>
            <vsa-content>
              De SSN regelt de <a target="_blank" href="https://www.snn.nl/ondernemers/investeringsregeling-reductie-stikstof"
              >subsidie</a>. Neem contact met ons op en wij kunnen u helpen met de formaliteiten van het aanvragen van de subsidie en het bestellen van een StruVital systeem.
            </vsa-content>
          </vsa-item>
          <vsa-item>
            <vsa-heading>
              Hoe lang is de levertijd na bestelling?
            </vsa-heading>
            <vsa-content>
              Het duurt minimaal 3 maanden voordat we uw nieuwe StruVital-systeem kunnen monteren en installeren. Gemaakt in Nederland.
            </vsa-content>
          </vsa-item>
          <vsa-item>
            <vsa-heading>
              Is de vloeistof schadelijk voor de koeien?
            </vsa-heading>
            <vsa-content>
              Nee, het is juist goed voor de koeien, zo voorkomt en geneest het infecties bij koepoten.
            </vsa-content>
          </vsa-item>       
        </vsa-list>
        <br>
      <br/><br/>
      </div>
    </div>
  </div>

  </section>
</template>

<script>
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
} from 'vue-simple-accordion';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
import { SectionProps } from '@/utils/SectionProps.js'

export default {
  name: 'Faqs',
  mixins: [SectionProps],
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
  },
}
</script>
<style>
.vsa-list {
  --vsa-max-width:1024;
}
</style>